<template>
  <ul class="rm-list rm-card">
    <li v-for="slip in slips" :key="slip.key" class="gm-slip" :data-shift="shift">
      <span class="rm-avatar rm-avatar--lg">{{ slip.initials }}</span>
      <div class="gm-slip__body">
        <div class="gm-slip__top">
          <span class="gm-slip__name">{{ slip.name }}</span>
          <span v-if="slip.no" class="gm-slip__no rm-num">#{{ slip.no }}</span>
        </div>
        <template v-for="category in slip.categories">
          <div :key="`${category.name}-title`" class="gm-slip__cat">{{ category.name }}</div>
          <div v-for="(meal, index) in category.meals" :key="`${category.name}-${index}`" class="gm-slip__meal">
            <b v-if="layout !== 1" class="rm-num">{{ meal.quantity }}<template v-if="layout === 0">× </template></b>
            <span v-if="layout !== 2">{{ meal.name }}</span>
          </div>
        </template>
        <div v-if="slip.note" class="gm-slip__note">{{ slip.note }}</div>
      </div>
    </li>
  </ul>
</template>

<script>
/**
 * Radnici jedne smene sa obrocima po grupama jela (Naručeno i Naručioci na telefonu). Samo prikazuje; layout:
 * 0 = količine i nazivi, 1 = samo nazivi, 2 = samo količine.
 */
export default {
  name: "GroupMobileSlipList",
  props: {
    /** [{ key, name, initials, no, note, categories: [{ name, meals: [{ quantity, name }] }] }] */
    slips: { type: Array, default: () => [] },
    shift: { type: Number, default: 1 },
    layout: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss">
.gm-slip {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--rm-divider-soft);

  &:last-child {
    border-bottom: none;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }

  &__name {
    min-width: 0;
    font-size: 15px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  &__no {
    flex: none;
    font-size: 12px;
    color: var(--rm-muted);
  }

  &__cat {
    margin-top: 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--rm-muted);
  }

  &__meal {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-top: 3px;
    font-size: 14px;
    line-height: 1.35;
    overflow-wrap: anywhere;

    b {
      flex: none;
      font-weight: 700;
    }
  }

  &__note {
    margin-top: 8px;
    font-size: 13px;
    color: var(--rm-muted);
    overflow-wrap: anywhere;
  }
}

@for $n from 1 through 4 {
  .rm-theme .gm-slip[data-shift="#{$n}"] .rm-avatar {
    background: var(--rm-shift-#{$n}-bg);
    color: var(--rm-shift-#{$n}-fg);
  }

  .gm-slip[data-shift="#{$n}"] .gm-slip__meal b {
    color: var(--rm-shift-#{$n}-fg);
  }
}
</style>
